import yup from '../../Utils/yup';

export const addInputToOfferTemplateFormRules = yup.object().shape({
  label: yup.string().required(),
  type: yup.string().oneOf(['text', 'money', 'date', 'numeric']).required(),
  currency: yup.string().when('type', {
    is: 'money',
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.optional()
  })
});
